import { ArrowDown, ArrowUp, Plus, X } from "lucide-react"

/**
 * Las funciones escritas a mano de un cargo, con su orden.
 *
 * ⚠ **El orden es el que sale impreso en el contrato**, y se cambia con botones y no
 * arrastrando: WCAG 2.5.7 exige una alternativa de un solo puntero.
 */
export function FuncionesEditables({
  funciones,
  onCambiar,
}: {
  funciones: string[]
  onCambiar: (funciones: string[]) => void
}) {
  const mover = (i: number, salto: number) => {
    const destino = i + salto
    const actual = funciones[i]
    const vecina = funciones[destino]
    if (actual === undefined || vecina === undefined) return
    const copia = [...funciones]
    copia[i] = vecina
    copia[destino] = actual
    onCambiar(copia)
  }

  return (
    <>
      <h3 className="rotulo mb-2">Funciones escritas a mano</h3>
      <ul className="space-y-2">
        {funciones.map((f, i) => (
          <li
            // El índice ES la identidad aquí: una función no tiene id, y su posición
            // es justamente el dato que se está editando.
            // biome-ignore lint/suspicious/noArrayIndexKey: una funcion no tiene id
            key={`f-${i}`}
            className="flex flex-wrap items-start gap-2 sm:flex-nowrap"
          >
            <input
              className="campo min-w-0 basis-full sm:flex-1 sm:basis-auto"
              aria-label={`Función ${i + 1}`}
              value={f}
              onChange={(e) => {
                const copia = [...funciones]
                copia[i] = e.target.value
                onCambiar(copia)
              }}
            />
            {/* En un teléfono la frase va entera arriba y los botones debajo: al lado,
                el campo se quedaba en media frase y había que desplazarlo para leerla. */}
            <div className="ml-auto flex shrink-0 gap-2">
              <button
                type="button"
                onClick={() => mover(i, -1)}
                disabled={i === 0}
                aria-label={`Subir la función ${i + 1}`}
                className="boton-secundario h-9 w-9 justify-center p-0"
              >
                <ArrowUp size={14} aria-hidden={true} />
              </button>
              <button
                type="button"
                onClick={() => mover(i, 1)}
                disabled={i === funciones.length - 1}
                aria-label={`Bajar la función ${i + 1}`}
                className="boton-secundario h-9 w-9 justify-center p-0"
              >
                <ArrowDown size={14} aria-hidden={true} />
              </button>
              <button
                type="button"
                onClick={() => onCambiar(funciones.filter((_, j) => j !== i))}
                aria-label={`Quitar la función ${i + 1}`}
                className="boton-secundario h-9 w-9 justify-center p-0"
              >
                <X size={14} aria-hidden={true} />
              </button>
            </div>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={() => onCambiar([...funciones, ""])}
        data-testid="anadir-funcion"
        className="boton-secundario mt-2 h-8 px-2 text-xs"
      >
        <Plus size={14} aria-hidden={true} />
        Añadir función
      </button>
    </>
  )
}
